module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/notosanskr/notokr-medium.woff2
// module id = uu3B
// module chunks = 0